/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {SortDirection} from '../../api/generic/contracts/sort-direction.enum';
import {SpoListFilterColumnEnum} from '../spo-main-page/spo-list/spo-list-filter-column.enum';
import {SpecialOrderQueryModel} from '../../api/ms-specialorders/contracts/special-order-query.model';
import {CodeFilterStateModel} from '../../shared/filter/code-filter/code-filter-state.model';
import {AbstractSearchCriteriaService} from '../../shared/filter/abstract-search-criteria.service';

@Injectable({
    providedIn: 'root'
})
export class SpoSearchCriteriaService extends AbstractSearchCriteriaService<SpoListFilterColumnEnum> {
    /**
     * Clear all the criteria
     */
    clear(): void {
        // clear stored filters
        this.stateMap.clear();
        // Sort criteria
        this.sortDirection = SortDirection.DESC;
        this.sortedBy = SpoListFilterColumnEnum.LAST_CHANGE_DATETIME;
        // Pagination
        this.pageSize = 20;
        this.pageNumber = 1;
        this.totalResults = 0;
    }

    public getSpoQuery(hasPaginationCriteria?: boolean): SpecialOrderQueryModel {
        const partnerCodes = this.mapCodeCriterion(SpoListFilterColumnEnum.PARTNER);
        const supplyingPackingPlantCodes = this.mapCodeCriterion(SpoListFilterColumnEnum.SUPPLYING_PACKING_PLANT);
        const reasonCodes = this.mapNullableStringListCriterion(SpoListFilterColumnEnum.REASON);
        const requestedDate = this.mapNullableDateCriterion(SpoListFilterColumnEnum.REQUESTED_DATE);
        const changedOn = this.mapDateCriterion(SpoListFilterColumnEnum.LAST_CHANGE_DATETIME);
        const specialOrderStatusCodes = this.mapCodeCriterion(SpoListFilterColumnEnum.NUMBER);
        const specialOrderMaterialStatusCodes = this.mapCodeCriterion(SpoListFilterColumnEnum.SPO_MAT_STATUS);
        const number = this.mapStringCriterion(SpoListFilterColumnEnum.NUMBER);
        const sentDate = this.mapDateCriterion(SpoListFilterColumnEnum.SENT_DATE);
        const numberOfMaterials = this.mapQuantityCriterion(SpoListFilterColumnEnum.NUMBER_OF_MATERIALS);
        const material = this.mapStringCriterion(SpoListFilterColumnEnum.NUMBER_OF_MATERIALS);

        const alertsStateModel = this.stateMap.get(SpoListFilterColumnEnum.MATERIAL_ALERTS) as CodeFilterStateModel;
        const alerts = alertsStateModel != null && alertsStateModel.all !== true && alertsStateModel.empty != null
                ? !alertsStateModel.empty
                : null;

        return {
            searchCriteria: {
                partnerCodes,
                supplyingPackingPlantCodes,
                reasonCodes,
                requestedDate,
                changedOn,
                specialOrderStatusCodes,
                specialOrderMaterialStatusCodes,
                number,
                sentDate,
                numberOfMaterials,
                material,
                specialOrderMaterialAlert: alerts
            },
            paginationCriteria: hasPaginationCriteria ? this.paginationCriteria : this.resetPaginationCriteria
        };
    }
}
